import { useQuery } from '@tanstack/react-query'
import { Link } from 'react-router-dom'
import { formatEur } from '@wf/shared'
import { api } from '../api/client'
import { STATUS_LABEL } from './labels'

/** Offene Posten: fertige/abgeholte, noch nicht bezahlte Aufträge mit Auftragswert + Gesamtsumme. Read-only;
 *  jede Zeile öffnet den Auftrag (dort wird kassiert/bezahlt gesetzt). */
export function OpenItemsPage() {
  const { data, isLoading, error } = useQuery({ queryKey: ['openItems'], queryFn: api.listOpenItems })

  if (isLoading) return <div className="muted">Offene Posten werden geladen…</div>
  if (error) {
    return (
      <div className="error" role="alert">
        Offene Posten konnten nicht geladen werden.
      </div>
    )
  }
  const items = data?.items ?? []

  return (
    <section className="wf-view">
      <div>
        <h2 className="viewtitle">Offene Posten</h2>
        <p className="sub">Fertige Aufträge, noch nicht bezahlt</p>
      </div>
      {data && data.count > 0 ? (
        <div className="wf-billsummary">
          <div className="wf-stat">
            <div className="wf-stat__value">{data.count}</div>
            <div className="wf-stat__sub">Offene Posten</div>
          </div>
          <div className="wf-stat">
            <div className="wf-stat__value wf-stat__value--sm wf-stat__value--due">{formatEur(data.totalCents)}</div>
            <div className="wf-stat__sub">Summe offen</div>
          </div>
        </div>
      ) : null}
      {items.length === 0 ? (
        <div className="wf-empty">
          <div className="wf-empty__title">Keine offenen Posten</div>
          <div className="wf-empty__text">Fertige, unbezahlte Aufträge erscheinen hier.</div>
        </div>
      ) : (
        <div className="wf-rowlist">
          {items.map((item) => (
            <Link key={item.id} to={`/orders/${item.id}`} className="wf-card wf-billrow">
              <span className="wf-tnum wf-billrow__no">{item.nr ?? item.id}</span>
              {item.plate ? (
                <span className="wf-plate">
                  <span className="wf-plate__eu">D</span>
                  <span className="wf-plate__nr">{item.plate}</span>
                </span>
              ) : null}
              <span className="wf-billrow__cust">{item.customerName ?? item.vehicleModel ?? ''}</span>
              <span className="wf-billrow__end">
                <span className={`wf-pill wf-pill--${item.status}`}>{STATUS_LABEL[item.status] ?? item.status}</span>
                <span className="wf-tnum">{formatEur(item.valueCents)}</span>
              </span>
            </Link>
          ))}
        </div>
      )}
    </section>
  )
}
